import React, { useEffect, useState } from "react";
import { defaultImageUrl, defaultLogo, ProductVariantDisplayType } from "../../pages/constant/Constants";
import Upcoming from "./../../assets/images/Upcoming.png";

const ImageRowVarient = ({
  variant_attribute,
  setValues,
  values,
  selectedVariant,
  variantImages,
  setCombineSelectedImage,
  setVariantValues,
  settingData,
  FindDisplayType
}) => {

  const [activeImage, setActiveImage]  = useState(() => {
   
      return values?.[variant_attribute.name] || "";
  });

  const categoryHandle = (values) => {
    
    setActiveImage(values);
    setValues((prev) => ({ ...prev, [variant_attribute.name]: values }));
    setVariantValues(values)
    // setFilter((filter) => {
    //   return{ ...filter, category_ids: id}
    // })
  };
  const getImageStyle = (style) => {
    return activeImage === style ? "activeImage" : "";
  };

  const showAttributes = ({ image }) => {
    if (settingData.hide_no_image_products == true && [undefined, "undefined", defaultImageUrl].includes(variantImages?.[variant_attribute?.name]?.[image])) {
      return null
    }
    return (
      <div style={{ display: "flex", flexDirection: "column" }}>
        <div
          className={`${getImageStyle(image)} thumbnail`}
          style={{ margin: "5px", margin: "20px 16px 16px 0px" }}
          onClick={() => {
            setCombineSelectedImage(variantImages?.[variant_attribute?.name]?.[image])
            categoryHandle(image)
          }}
        >
          <img
            src={
              variantImages?.[variant_attribute?.name]?.[image] === defaultImageUrl
                ? (settingData.logo || Upcoming)
                : variantImages?.[variant_attribute?.name]?.[image]
            }
            alt={image}
          />
        </div>
        <p>{image}</p>
      </div>
    )
  }

  return (
    <>
      <div style={{display:"flex", justifyContent:"space-between"}}>
          <label
            className="varient-name"
          >
            {variant_attribute.name}
          </label>
            {variant_attribute?.attachment ?
            <a href={variant_attribute.attachment} target="_blank">
            <img src={process.env.PUBLIC_URL + "/media/icons/size_guide_img.png"} style={{height:"24px", width:"24px"}} alt="" />
          <label 
              style={{
              fontFamily: "Montserrat",
              fontSize: "18px",
              fontWeight: "400",
              lineHeight: "22px",
              letterSpacing: "0em",
              textAlign: "left",
              marginLeft: "8px",
              cursor: "pointer",
          }}>
              {variant_attribute?.attachment_name}
          </label>
          </a>
          : null
          }
        </div>
      <div className="gallery">
        <div style={{ display: "flex", alignItems: "center", flexFlow:"wrap" }}>
          {variant_attribute.value.map((image) => (
            <>
              {showAttributes({ image })}
            </>
          ))}
        </div>
      </div>
    </>
  );
};
export default ImageRowVarient;
